module.exports = __webpack_public_path__ + "img/company-logo.7a0cb4e7.svg";